export class AdminApproveBlogsController {
	constructor($scope, $modal, BlogService, $timeout) {
		this.scope = $scope;
		this.modal = $modal;
		this.BlogService = BlogService;
		this.timeout = $timeout;
		this.scope.vm = this;
    this.scope.allBlogs = [];
    this.scope.allCategories = [];

		this.scope.pagination = {
			total: 0,
			currentPage: 1,
			limit: 12
		};

    this.scope.blogFormModel = {
      title: '',
      content: '',
      category: {
        _id: '',
        name: '',
        url: ''
      }
    }

    this.scope.filter = {
      confirmed: true,
      unconfirmed: true
    }

    this.scope.show = {
      list: true,
      edit: false
    }

    this.scope.allBlogsSelected = { state: false };
    this.scope.blogsSelected = {};
    this.scope.errors = [];

		this.scope.feedback = {
      toId: '',
      fromId: '',
      reason: '',
      extraMessage: ''
    };

    this.scope.showModal = {
      feedback: false
    };

		this.scope.feedbackMessages = [
      {
        'id': 1,
        'text': 'Personal',
        'value': 'Estimado Usuario:\n\n\n\n\n\n' +
        '\nAtentamente\n' + 'Datingchile.cl' + '\n'
      },
		  {
        'id': '2',
        'text': 'Generico',
        'value': 'Disculpa, hemos rechazado tu blog debido a que no cumple con las condiciones del sitio.\n'+
                 'Datingchile.cl' + '\n'
      }
    ];

		this.init();
	}

	init() {
		this.scope.changeLimit = () => {
      this.timeout.cancel(this.limitTimout);

      this.limitTimout = this.timeout(() => {
        this.scope.getBlogs(1);
      }, 200);
    }

    this.BlogService.getCategories()
        .then((response) => { let categories = response.data;
          _.forEach(categories.data, (category) => {
            this.scope.allCategories.push(category);
          });
        })
        .catch((response) => { let error = response.data;
          console.log(error);
        });

    this.scope.getBlogs = (page, query) => {
      this.scope.pagination.currentPage = page;

      this.BlogService.getAllBlogs(page, this.scope.pagination.limit, query)
        .then((response) => { let data = response.data;
          this.scope.allBlogs = data.data;
          this.scope.pagination.total = data.itemCount;

          // Remove old users' keys when being navigated to new page
          this.scope.blogsSelected = {};

          _.forEach(this.scope.allBlogs, (blog) => {
            this.scope.blogsSelected[blog._id] = false;
          });

          this.scope.allBlogsSelected.state = false;
        })
        .catch((response) => { let e = response.data;
            console.log(e);
        });
    }

		this.scope.openFeedbackModal = () => {
      var stop = true;

      _.forEach(this.scope.blogsSelected, (value, key) => {
        if(value) {
          stop = false;
        }
      });

      if(stop) {
        return;
      }

      this.scope.hideModal();
      this.scope.showModal.feedback = true;
      //this.scope.feedback.toId = userId;
      $('#modal').modal('show');
    }

    this.scope.hideModal = () => {
      this.scope.showModal.feedback = false;
      this.scope.showModal.image = false;
    };

		this.scope.sendFeedback = (formReport) => {

      if (!formReport.$valid) {
        this.formValidationForReport(formReport);
        return;
      }

      if (this.scope.feedback.reason === "" || this.scope.feedback.extraMessage === "") {
        this.toastr.error('Feedback hasn\'t sent. You must add message');
        return;
      }

      this.scope.rejectBlogs();
    }


    this.scope.filterBlogs = () => {
      if(this.scope.filter.confirmed && this.scope.filter.unconfirmed) {
        var query = {};
        this.scope.getBlogs(this.scope.pagination.currentPage, query);
      }
      else if(this.scope.filter.confirmed && !this.scope.filter.unconfirmed) {
        var query = {status: false};
        this.scope.getBlogs(this.scope.pagination.currentPage, query);
      } else if(!this.scope.filter.confirmed && this.scope.filter.unconfirmed) {
        var query = {status: true};
        this.scope.getBlogs(this.scope.pagination.currentPage, query);
      } else {
        this.scope.allBlogs = [];
        this.scope.pagination.total = 0;
        this.scope.blogsSelected = {};
      }
    }

    /**
     * Check every checkbox on the page
     */
    this.scope.selectAllBlogs = () => {
      var check = this.scope.allBlogsSelected.state;

      _.forEach(this.scope.blogsSelected, (blog, key) => {
        this.scope.blogsSelected[key] = !!check;
      })
    };

    this.scope.editBlog = (blog) => {
      this.scope.blogFormModel = angular.copy(blog);

      this.scope.show.edit = true;
      this.scope.show.list = false;
    }

    this.scope.updateBlog = (form) => {
      this.scope.errors = [];
      _.forEach(form, (obj, key) => {
        if(key[0] == "$") {
          return;
        }

        _.forEach(obj.$error, (err, keyErr) => {
          if(keyErr == 'required') {
            this.scope.errors.push('The ' + key + ' is required!')
          }
        })
      })

      if(this.scope.errors.length) {
        return false;
      }

      this.BlogService.updateBlog(this.scope.blogFormModel)
        .then((response) => { let result = response.data;
          // Editing a blog leaves it in the list, so nothing was removed.
          this.scope.refreshPage(0);
        })
        .catch((response) => { let err = response.data;
          console.log(err);
        });
    }

    this.scope.rejectBlogs = () => {
			if(!confirm('Do you really want to reject blog?')) {
				return;
			}

      var countdown = 0;

      _.forEach(this.scope.blogsSelected, (val, key) => {
        if (val) {
          countdown++;
          this.BlogService.rejectBlog(key, {
						reason: this.scope.feedback.reason,
						motivation: this.scope.feedback.extraMessage
					})
            .then((response) => { let result = response.data;
              countdown--;
              if (countdown == 0) {
								// Reset fields
		            this.scope.feedback.reason = '';
		            this.scope.feedback.extraMessage = '';

		            $('#modal').modal('hide');
                this.scope.refreshPage();
              }
            })
            .catch((response) => { let err = response.data;
              countdown--;
              if (countdown == 0) {
								// Reset fields
		            this.scope.feedback.reason = '';
		            this.scope.feedback.extraMessage = '';

		            $('#modal').modal('hide');

                this.scope.refreshPage();
              }
            });

        }
      });
    }

    this.scope.deleteBlogs = () => {
			if(!confirm('Do you really want to delete blog?')) {
				return;
			}

      var countdown = 0;
      _.forEach(this.scope.blogsSelected, (val, key) => {
        if (val) {
          countdown++;
          this.BlogService.removeBlog(key)
            .then((response) => { let result = response.data;
              countdown--;
              if (countdown == 0) {
                this.scope.refreshPage();
              }
            })
            .catch((response) => { let err = response.data;
              countdown--;
              if (countdown == 0) {
                this.scope.refreshPage();
              }
            });

        }
      });
    }

		this.scope.approveBlogs = () => {
			if(!confirm('Do you really want to approve blog?')) {
				return;
			}

      var countdown = 0;

      _.forEach(this.scope.blogsSelected, (val, key) => {
        if (val) {
          countdown++;
          this.BlogService.approveBlog(key)
            .then((response) => { let result = response.data;
              countdown--;
              if (countdown == 0) {
                this.scope.refreshPage();
              }
            })
            .catch((response) => { let err = response.data;
              countdown--;
              if (countdown == 0) {
                this.scope.refreshPage();
              }
            });

        }
      });
		}

    this.scope.refreshPage = (itemsRemoved) => {
      // Defaults to the checked blogs, who are the ones rejecting and deleting
      // take out of the list. Callers that remove nobody pass 0.
      if (itemsRemoved === undefined) {
        itemsRemoved = _.size(this.scope.blogsSelected);
        _.forEach(this.scope.blogsSelected, (val, key) => {
          if (val === false) { itemsRemoved--; }
        } );
      }

      // Stay on the current page unless the removals put it past the end of the
      // shortened list. filterBlogs() reads the page back off currentPage.
      var lastPage = Math.max(1, Math.ceil((this.scope.pagination.total - itemsRemoved) / this.scope.pagination.limit));
      this.scope.pagination.currentPage = Math.min(this.scope.pagination.currentPage, lastPage);

      this.scope.filterBlogs();
      this.scope.show.list = true;
      this.scope.show.edit = false;
    }

    this.scope.filterBlogs();
	}
}
